import { AdminGuard } from '@/components/admin-guard';
import { createFileRoute } from '@tanstack/react-router';
import { KbCollectionsAdminView } from '@/features/kb/KbCollectionsAdminView';
import { AdminSubNav } from '@/components/shell/AdminSubNav';

function KbCollectionsAdmin() {
  return (
    <>
      <AdminSubNav />
      <KbCollectionsAdminView />
    </>
  );
}

export const Route = createFileRoute('/admin/kb-collections')({
  component: () => (
    <AdminGuard>
      <KbCollectionsAdmin />
    </AdminGuard>
  )
});
